import { browserPageReducer } from '../slices/browserPage';
import { chatReducer } from '../slices/chat';
import { comparisonNotificationReducer } from '../slices/comparisonNotification';
import { complaintsReducer } from '../slices/complaints';
import { earlyAccessReducer } from '../slices/earlyAccess';
import { experimentsReducer } from '../slices/experiments';
import { jsonQueryReducer } from '../slices/jsonQuery';
import { listingLayoutReducer } from '../slices/listingLayout';
import { mapConfigurationReducer } from '../slices/mapConfiguration';
import { mapControlsReducer } from '../slices/mapControls';
import { userReducer } from '../slices/user/slice';

export const rootReducer = {
  browserPage: browserPageReducer,
  chat: chatReducer,
  jsonQuery: jsonQueryReducer,
  listingLayout: listingLayoutReducer,
  mapConfiguration: mapConfigurationReducer,
  mapControls: mapControlsReducer,
  complaints: complaintsReducer,
  comparisonNotification: comparisonNotificationReducer,
  experiments: experimentsReducer,
  earlyAccess: earlyAccessReducer,
  user: userReducer,
};
